export const MAX_CONNECTIONS_PREVIEW = 7;
export const MAX_PREVIEW = 2;
export const MAX_LIBRARY_PREVIEW = 5;
